import { ResumenDescuentosFacade } from 'src/app/pago/services/resumen-descuentos/resumen-descuentos-facade.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-resumen-descuentos',
  templateUrl: './resumen-descuentos.component.html',
})
export class ResumenDescuentosComponent {
  constructor(public resumenDescuentosFacade: ResumenDescuentosFacade) {}
}
